define(function (require) {
  var $ = require("jquery");
  var _ = require("underscore");
  var get = require("lodash.get");
  var Mustache = require("mustache");
  var PageConfig = require("common/page-config");
  var InputFocus = require("site/common/input-focus");
  var radioGroups = require("site/common/radio");
  var DefaultValidationOptions = require("site/common/input-validation");
  var Events = require("common/event-aggregator");
  var RegisterProfileView = require("./register-profile");
  var AccountInformation = require("site/common/user/account-information");
  var config = require("common/page-config");
  var language = require("common/util/language");
  var {
    mParticleCustomEventRegister,
    mParticleLogin,
    mParticleGetInstance
  } = require("common/analytics/mParticle");
  const isNewRegisterAPIsEnabled = _.contains(
    PageConfig.uiChannelFeatures,
    "USE_NEW_ACCOUNT_API"
  );

  if (PageConfig.alternateAppUri) {
    window.location = PageConfig.alternateAppUri;
  }

  var $registerForm;

  var invalidHandler = function (event, validator) {
    _.mapObject(validator.invalid, function (value, key) {
      Events.trigger(Events.VALIDATION_FIELD_INVALID, key, value);
    });

    InputFocus.focusFirstErrorInput(
      $registerForm,
      Object.keys(validator.invalid)
    );
  };

  function showMinimalForm (authenticatedAccount, newsletter) {
    $("#email-address").val(authenticatedAccount.email);

    if (authenticatedAccount.firstName) {
      $("#last-name").val(authenticatedAccount.firstName);
      $("#first-name").parents(".form-row").addClass("authenticated-account");
    }
    if (authenticatedAccount.lastName) {
      $("#last-name").val(authenticatedAccount.lastName);
      $("#last-name").parents(".form-row").addClass("authenticated-account");
    }
    if (authenticatedAccount.postalRef) {
      $("#postal-ref").val(authenticatedAccount.postalRef);
    }
    if (authenticatedAccount.gender) {
      $("#last-name").parents(".form-row").addClass("authenticated-account");

      if (authenticatedAccount.gender === "MALE") {
        $("#genderMale").click();
      }
    }
    if (newsletter) {
      $("#newsletter").parents(".form-row").addClass("authenticated-account");
    }
    $(".authenticated-account").parents(".foundation-form-row").hide();

    var authenticatedTitle = $registerForm.data("authenticated-title");
    var authenticatedNote = $registerForm.data("authenticated-note");

    $(".popup-title .value").html(authenticatedTitle);
    $registerForm.find(".section-title .note").html(authenticatedNote);
  }

  var validationOptions = {
    rules: {},
    messages: {},
    invalidHandler: invalidHandler
  };

  var canSubmit = function () {
    // check if button has class processing
    return !$(".main-button", $registerForm).hasClass("processing");
  };

  var attachValidation = function (aView, callback, passwordRulesPromise) {
    function validateForm () {
      _.extend(
        validationOptions,
        {
          focusInvalid: true,
          submitHandler (form, evt) {
            // prevent event default
            evt.preventDefault();
            // run callback if not processing
            if (canSubmit()) {
              callback();
            }
          }
        },
        DefaultValidationOptions
      );

      // add validation to form
      $registerForm.validate(validationOptions);
    }

    _.each(aView, function (view) {
      if (!view.validation) {
        return;
      }

      function useValidationRules () {
        // get rules and messages
        if (view.validation.rules) {
          _.extend(validationOptions.rules, view.validation.rules);
        }
        if (view.validation.messages) {
          _.extend(validationOptions.messages, view.validation.messages);
        }
        if (isNewRegisterAPIsEnabled && view.validation.onkeyup) {
          validationOptions.onkeyup = view.validation.onkeyup;
        }
      }

      if ($.isFunction(view.validation) && isNewRegisterAPIsEnabled) {
        passwordRulesPromise.then((response) => {
          if (response === "APIError") {
            if ($.isFunction(view.validation)) {
              view.validation = view.validation();
            }
            useValidationRules();
            validateForm();
          } else {
            view.validation = view.validation(response.passwordRules);
            useValidationRules();
            validateForm();
          }
        });
      }

      if ($.isFunction(view.validation) && !isNewRegisterAPIsEnabled) {
        view.validation = view.validation();
      }

      if (!isNewRegisterAPIsEnabled) {
        useValidationRules();
      }
    });

    if (!isNewRegisterAPIsEnabled) {
      validateForm();
    }
  };

  var toggleButton = function (processing) {
    var btnSubmit = $(".main-button", $registerForm);

    if (processing) {
      btnSubmit.addClass("processing button-hover");
      return true;
    }

    btnSubmit.removeClass("processing button-hover");
    return true;
  };

  var getTemplateData = function (type) {
    var cms = config.cms.verifyPassword[type];
    var messageType = !type ? "email-sent" : type;
    var data = {
      title: cms.title || null,
      text: cms.text || null,
      description: cms.description || null,
      messageClass: messageType
    };

    if (cms.link) {
      _.extend(data, {
        cta: {
          label: cms.link.label || null,
          uri: cms.link.uri ? cms.link.uri : null,
          btnClasses: cms.link.uri ? "button main-button" : "link"
        }
      });
    }

    return data;
  };

  var showVerifyMessage = function (typeData, callback) {
    var successTemplate = $("#form-register-message-template").html();

    $registerForm.addClass("finished");

    if ($registerForm.find(".verifyMessage").length === 0) {
      $registerForm.append($("<div />").addClass("verifyMessage"));
    }

    $registerForm
      .find(".verifyMessage")
      .html(Mustache.render(successTemplate, typeData));

    if (callback && typeof callback === "function") {
      // attach event to the resend link
      $registerForm.find(".action-link").on("click", callback);
    }
  };

  var resendVerificationEmail = function (email) {
    $.ajax({
      async: true,
      url: "/api/account/password-auth-verification",
      type: "POST",
      data: {
        email: email
      }
    })
      .done(function (responseData, status, xhr) {
        if (xhr.status === 204) {
          var data = getTemplateData("email-resent");

          data.text = data.text.replace(
            "[[customerServiceNumber]]",
            config.customerServiceNumber
          );

          showVerifyMessage(data);
        }
      })
      .fail(function (responseData) {
        var data;

        if (responseData.status === 422) {
          if (responseData.responseJSON === "ALREADY_VERIFIED") {
            data = getTemplateData("account-already-verified");
          } else {
            data = getTemplateData("error-" + responseData.responseJSON);
          }

          showVerifyMessage(data);
        }
      });
  };

  var handleSuccess = function (data, callback) {
    const hasMarketingOptedIn =
      data.newsletter || (isNewRegisterAPIsEnabled && data.newsletterSignup)
        ? true
        : false;
    mParticleCustomEventRegister("password", hasMarketingOptedIn);

    const redirectAfterRegistration =
      data.status === "OKAY" ||
      data.status === "REQUIRES_PASSWORD_VERIFICATION" ||
      (isNewRegisterAPIsEnabled &&
        data.result.toLowerCase() === "authenticated");

    if (redirectAfterRegistration) {
      // Check if form is in page or popup
      if (PageConfig.registerInPopup) {
        // load accountInformation
        AccountInformation.refresh();
        // run callback if exists
        if (callback) {
          callback();
        }
        return;
      }

      // Check for the verify channel feature
      if (
        _.contains(
          config.uiChannelFeatures,
          "ACCOUNT_PASSWORD_AUTH_VERIFICATION"
        )
      ) {
        $registerForm.find(".fields").remove();
        $(".ui-header .button-back").remove();

        showVerifyMessage(getTemplateData("email-sent"), function () {
          resendVerificationEmail(data["email-address"]);
        });
      } else {
        const searchParams = new URLSearchParams(window.location.search);
        const langPath = language.getLanguagePath(window.location.pathname);

        let nextPageHref = "/account";

        if (searchParams.has("finalizeOrder")) {
          searchParams.delete("finalizeOrder");

          nextPageHref = `/secure-checkout?${searchParams.toString()}`;
        }

        if (searchParams.has("referralCode")) {
          nextPageHref = `/?referral=${searchParams.get("referralCode")}`;
        }

        window.location.href = langPath + nextPageHref;
      }
    }
  };

  var handleError = function (jqXHR) {
    var errorName = get(jqXHR, "responseJSON.errors[0]");
    toggleButton(false);

    var errorNode = $("<div/>")
      .addClass("error-message")
      .append($("<span/>"));
    // Generic error defaults
    var errorText = PageConfig.failureMessage;
    var target = $(".form-register .main-button");
    if (errorName === "EMAIL_INVALID") {
      target = $("#email-address");
      target.closest(".form-row").addClass("error");
      target.one("input", () => target.closest(".form-row").removeClass("error"));
      target.focus();
      errorText = PageConfig.cms.validationMessages["email-address"].invalid_domain;
    }
    target.next(".error-message").remove();
    errorNode.find("span").text(errorText);
    errorNode.insertAfter(target);
    errorNode.show();
  };

  var getFormData = function (views) {
    var data = [];

    _.each(views, function (view) {
      if (typeof view.getValues === "function") {
        data = data.concat(view.getValues());
      }
    });

    return data;
  };

  var submit = function (data, callback) {
    var formData = {};

    // toggle button
    toggleButton(true);

    _.map(data, function (field) {
      if (isNewRegisterAPIsEnabled && field.name === "emailAddress") {
        formData.email = field.value;
      } else if (isNewRegisterAPIsEnabled && field.name === "newsletter") {
        formData.newsletterSignup = field.value;
      } else {
        formData[field.name] = field.value;
      }
    });

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has("referralCode")) {
      formData.referralCode = searchParams.get("referralCode");
    }

    if (isNewRegisterAPIsEnabled) {
      formData.cookies = true;
    }

    function success (responseData) {
      var doHandleSuccess = () => {
        handleSuccess(_.extend(responseData, formData), callback);
      };
      if (mParticleGetInstance()) {
        $.ajax({
          url: "/account-api/api/v1/me/information",
          type: "GET",
          contentType: "application/json",
          success: (meInformation) => {
            if (meInformation.loginStatus === "account_authenticated") {
              var userIdentities = {
                email: meInformation.email,
                customerid: meInformation.accountId.id.toString()
              };
              mParticleLogin({ userIdentities }, () => {
                doHandleSuccess();
              });
            }
          }
        });
      } else {
        doHandleSuccess();
      }
    }

    $.ajax({
      async: true,
      url: isNewRegisterAPIsEnabled ? "/api/v2/me" : "/ajax/site/register",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(formData),
      success,
      error: handleError
    });
  };

  var createView = function (
    callback,
    authenticatedAccount,
    passwordRulesPromise
  ) {
    if (!_.isEmpty(authenticatedAccount)) {
      $.ajax({
        url: "/ajax/site/account-newsletter-subscription/",
        type: "GET",
        success (data) {
          showMinimalForm(authenticatedAccount, data);
        }
      });
    }

    var views = [];

    views.push(new RegisterProfileView({ el: $(".form-register") }));
    // set form
    $registerForm = $(".form-register");
    // attach validation
    attachValidation(
      views,
      function () {
        submit(getFormData(views), callback);
      },
      passwordRulesPromise
    );
  };

  function accountInformationLoaded (
    callback,
    authenticatedAccount,
    passwordRulesPromise
  ) {
    // create view
    createView(callback, authenticatedAccount, passwordRulesPromise);
    // initialize input focus
    InputFocus.addClassWhenFocused($registerForm);
    InputFocus.focusFirstEmptyInput($registerForm);

    // add event to back button
    $(".button-back").on("click", function (evt) {
      evt.preventDefault();
      // go back in history
      window.history.back();
    });
  }

  var initialize = function (callback, passwordRulesPromise) {
    AccountInformation.get().done(function (profile) {
      var authenticatedAccount = {};

      if (
        profile.loginStatus === "ACCOUNT_AUTHENTICATED" ||
        profile.loginStatus === "PROFILE_AUTHENTICATED"
      ) {
        authenticatedAccount = profile;
      }

      accountInformationLoaded(
        callback,
        authenticatedAccount,
        passwordRulesPromise
      );
    });

    radioGroups.maintainCheckedClassOnLabels($(".radio input"));
  };

  return {
    initialize: initialize
  };
});
